import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ApiCacheProvider } from '@/pages/ApiCache.context';
import { ReviewProvider } from '@/pages/ReviewLayout.context';
import SuspenseLoader from '@/components/SuspenseLoader';
import { SignHeader } from '@/components/Header';
import { AppProvider } from './App.context';
import styles from './ReviewLayout.module.scss';

const ReviewLayout = () => {
  const [ready, setReady] = useState(false);

  // Wait one tick before rendering to avoid hydration issues.
  useEffect(() => {
    const id = requestIdleCallback(() => setReady(true));
    return () => cancelIdleCallback(id);
  }, []);

  if (!ready) {
    return <SuspenseLoader />;
  }

  /*
   * Please do not add any Suspense here as this feels somehow broken!
   * */
  return (
    <ApiCacheProvider token={sessionStorage.getItem('token')}>
      <AppProvider>
        <SignHeader />
        <ReviewProvider>
          <main className={styles.main}>
            <Outlet />
          </main>
        </ReviewProvider>
      </AppProvider>
    </ApiCacheProvider>
  );
};

export default ReviewLayout;
